import { useEffect, useState, useContext } from 'react';
import $ from "jquery";
import { Card, ListGroup, Container, Row, Col, Badge } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import UserContext from '../../contexts/UserContext';

const Daycount = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const { user, setUser } = useContext(UserContext);

    const getUser = async (userId) => {
        try {
            const response = await $.ajax({
                type: "GET",
                url: process.env.REACT_APP_API_URL + "/getUsers/" + userId,
                xhrFields: { withCredentials: true },
                crossDomain: true
            });

            if (response && response.user) {
                setUser(response.user);
            } else {
                setUser(null);
                navigate("/login");
            }
        } catch (error) {
            console.log("Error getting user:", error);
            navigate("/login");
        }
    };

    function getData() {
        $.ajax({
            type: "GET",
            url: process.env.REACT_APP_API_URL + "/attendanceCounts",
            xhrFields: { withCredentials: true },
            crossDomain: true,
            success: function (response) {
                if (response.message && response.message.includes("Error in auth")) {
                    navigate("/login", { state: { message: response.message } });
                }
                setData(response);
            },
            error: function (err) {
                console.log("error", err);
                navigate("/login");
            }
        });
    }

    const formatDate = (dateString) => {
        try {
            // Handle different date formats
            let dateObj;
            
            if (dateString.includes('/')) {
                // Handle MM/DD/YYYY format
                const dateParts = dateString.split("/");
                dateObj = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
            } else {
                // Handle other formats
                dateObj = new Date(dateString);
            }
            
            const today = new Date();
            const yesterday = new Date(today);
            yesterday.setDate(yesterday.getDate() - 1);
            
            if (dateObj.toDateString() === today.toDateString()) {
                return "Today";
            } else if (dateObj.toDateString() === yesterday.toDateString()) {
                return "Yesterday";
            } else {
                return dateObj.toDateString();
            }
        } catch (error) {
            return dateString;
        }
    };

    const getMealIcon = (mealType) => {
        return mealType === 'lunch' ? '🌅' : '🌙';
    };

    const getMealBadge = (mealType) => {
        return mealType === 'lunch' ? 
            <Badge bg="warning" text="dark">Lunch</Badge> : 
            <Badge bg="info">Dinner</Badge>;
    };

    // Group data by date to show lunch and dinner together
    const groupedData = data.reduce((acc, item) => {
        const dateKey = item.date;
        if (!acc[dateKey]) {
            acc[dateKey] = [];
        }
        acc[dateKey].push(item);
        return acc;
    }, {});

    useEffect(() => {
        try {
            if (!user && localStorage.getItem('userSession')) {
                getUser(JSON.parse(localStorage.getItem('userSession')));
            } else if (!user) {
                navigate("/login");
            }
        } catch (e) {
            if (!user) {
                navigate("/login");
            }
        }
        getData();
    }, []);

    return (
        <Container fluid className="px-3">
            <Row className="justify-content-center">
                <Col xs={12} sm={10} md={8} lg={6} xl={5}>
                    <h6 className="m-3 text-center" style={{color: '#c38154'}}>
                        Tiffin Distribution Count
                    </h6>
                    
                    {Object.keys(groupedData).length === 0 ? (
                        <Card className="mb-4">
                            <Card.Body className="text-center text-muted">
                                No distribution data available
                            </Card.Body>
                        </Card>
                    ) : (
                        // Sort dates in descending order (most recent first)
                        Object.keys(groupedData)
                            .sort((a, b) => {
                                // Parse dates for proper sorting
                                const dateA = a.includes('/') ? 
                                    new Date(a.split('/')[2], a.split('/')[0] - 1, a.split('/')[1]) :
                                    new Date(a);
                                const dateB = b.includes('/') ? 
                                    new Date(b.split('/')[2], b.split('/')[0] - 1, b.split('/')[1]) :
                                    new Date(b);
                                return dateB - dateA;
                            })
                            .map((dateKey) => {
                                const dayRecords = groupedData[dateKey];
                                
                                return (
                                    <Card key={dateKey} className="mb-4">
                                        <Card.Header style={{backgroundColor: '#c38154', color: 'white'}}>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span style={{fontWeight: 'bold'}}>
                                                    {formatDate(dateKey)}
                                                </span>
                                                <div>
                                                    {dayRecords.map(record => (
                                                        <span key={record.mealType} className="me-2">
                                                            {getMealIcon(record.mealType)}
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                        </Card.Header>

                                        <ListGroup variant="flush" className='custom-card'>
                                            {dayRecords.map((record, index) => (
                                                <ListGroup.Item className='custom-card' key={index}>
                                                    <div className="d-flex justify-content-between align-items-center" >
                                                        <div>
                                                            <div className="d-flex align-items-center mb-1">
                                                                {getMealBadge(record.mealType)}
                                                                <span className="ms-2" style={{color: '#c38154', fontWeight: 'bold'}}>
                                                                    {record.mealType.charAt(0).toUpperCase() + record.mealType.slice(1)}
                                                                </span>
                                                            </div>
                                                            <small className="text-muted">
                                                                Scanned by: {record.lastUpdatedUser}
                                                            </small>
                                                        </div>
                                                        <div className="text-end">
                                                            <div>
                                                                <strong style={{color: '#c38154'}}>
                                                                    {record.personCount} people
                                                                </strong>
                                                            </div>
                                                            <small className="text-muted">
                                                                {record.tiffinCount} tiffins
                                                            </small>
                                                        </div>
                                                    </div>
                                                </ListGroup.Item>
                                            ))}
                                        </ListGroup>

                                        {/* Summary footer if both meals exist */}
                                        {dayRecords.length > 1 && (
                                            <Card.Footer style={{backgroundColor: '#f8f9fa'}}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <small className="text-muted">Daily Total:</small>
                                                    <small style={{color: '#c38154', fontWeight: 'bold'}}>
                                                        {dayRecords.reduce((sum, record) => sum + record.personCount, 0)} people, {' '}
                                                        {dayRecords.reduce((sum, record) => sum + record.tiffinCount, 0)} tiffins
                                                    </small>
                                                </div>
                                            </Card.Footer>
                                        )}
                                    </Card>
                                );
                            })
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export default Daycount;